<template>
  <div>
    <div class="overflow-x-auto">
      <table
        v-if="initialData && initialData.length > 0"
        class="min-w-full divide-y divide-gray-200"
      >
        <thead class="bg-gray-50">
          <tr>
            <th
              scope="col"
              class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
            >
              City
            </th>
            <th
              scope="col"
              class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
            >
              {{ getMedianLabel }}
            </th>
            <th
              scope="col"
              class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
            >
              {{ getSalaryRangeLabel }}
            </th>
          </tr>
        </thead>
        <tbody
          class="bg-white divide-y divide-gray-200"
        >
          <CityTableRow
            v-for="city in processedData"
            :key="`${city.city}-${city.state}`"
            :city-data="city"
          />
        </tbody>
      </table>
      <TableEmptyState
        v-else
        message="No city data available for this role"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, watch } from 'vue'
import CityTableRow from './CityTableRow.vue'
import type { CityData } from '~/composables/useCitySalaryData'
import { useGlobalSalaryPeriod } from '~/composables/useGlobalSalaryPeriod'
import TableEmptyState from '~/components/ui/TableEmptyState.vue'

interface Props {
  permalink: string
  companyName: string
  role: string
  initialData?: CityData[]
}
const props = defineProps<Props>()
const roleRef = ref(props.role)
const { activePeriod, displayPeriods, adjustValueForPeriod }
  = useGlobalSalaryPeriod()
const getMedianLabel = computed(() => {
  const periodName
    = displayPeriods[activePeriod.value].charAt(0).toUpperCase()
      + displayPeriods[activePeriod.value].slice(1)
  return `Median ${periodName} Pay`
})
const getSalaryRangeLabel = computed(() => {
  const periodName
    = displayPeriods[activePeriod.value].charAt(0).toUpperCase()
      + displayPeriods[activePeriod.value].slice(1)
  return `${periodName} Pay Range`
})
const processedData = computed(() => {
  if (!props.initialData || !Array.isArray(props.initialData)) {
    return []
  }
  return props.initialData.map((city) => {
    const adjustedSalaryRange = {
      min: adjustValueForPeriod(city.salary_range?.min || 0),
      max: adjustValueForPeriod(city.salary_range?.max || 0)
    }
    return {
      ...city,
      median_salary: adjustValueForPeriod(city.median_salary || 0),
      salary_range: adjustedSalaryRange
    }
  })
})
watch(activePeriod, () => {}, { immediate: true })
</script>
